import React from 'react';
import './EventsJoin.css';
import userPhoto from './../../images/user-photo.jpg';
import eventsCountIcon from './../../images/events-count.svg';
import eventsMemberIcon from './../../images/chat-member-icon.svg';
import addressIcon from './../../images/address.svg';
import calendarIcon from './../../images/calendar.svg';
import axios from 'axios';

const EventsJoin = ({
    eventInfo,
    userLang,
    setCurrentPage,
    translations,
    isFullScreenMode,
}) => {
    // форматирование даты на местное время
    const formatDate = (eventDate) => {
        const date = new Date(eventDate);
        const timezoneOffset = date.getTimezoneOffset();
        date.setMinutes(date.getMinutes() - timezoneOffset);

        const day = date.getDate();
        const month = date.toLocaleString(userLang, { month: 'long' });
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');

        return `${day} ${month} | ${hours}:${minutes}`;
    };

    // присоединение к мероприятию
    const handleJoinClick = async () => {
        if (eventInfo.isAvailableJoin) {
            try {
                const response = await axios.post(
                    'https://mepointserver.ru/event/join',
                    { id: eventInfo.id },
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem(
                                'authToken'
                            )}`,
                        },
                    }
                );
                if (response.data.success) {
                    console.log('Присоединение');
                    alert(translations.eventApplication);
                    setCurrentPage('MapPage');
                }
            } catch (error) {
                console.error('Ошибка присоединения к мероприятию ', error);
            }
        }
    };

    return (
        <div className='events__join'>
            <div
                className={
                    isFullScreenMode
                        ? 'events__join_info_full'
                        : 'events__join_info'
                }
            >
                <img
                    className='user__photo'
                    src={`https://mepointserver.ru${eventInfo.ownerAvatarLink}`}
                />
                <div className='user__about'>
                    <h3 className='user__name'>{eventInfo.ownerName}</h3>
                    <div className='user__events'>
                        <h3 className='user__events_count'>
                            {eventInfo.ownerActiveEvents}
                        </h3>
                        <img
                            className='user__events_icon'
                            src={eventsCountIcon}
                        />
                    </div>
                </div>
            </div>
            <div className='events__join_container'>
                <div className='user__event_items'>
                    <div className='events__join_item'>
                        <h3 className='events__join_title'>
                            {eventInfo.subCategoryName}
                        </h3>
                        <div className='events__join_members'>
                            <p>
                                {eventInfo.membersCount}/
                                {eventInfo.membersLimit}
                            </p>
                            <img src={eventsMemberIcon} />
                        </div>
                    </div>
                    <div className='events__join_discription'>
                        <h5>Описание</h5>
                        <textarea disabled>{eventInfo.description}</textarea>
                    </div>
                    <div className='events__join_date'>
                        <div className='events__date_items'>
                            <img src={addressIcon} />
                            <p>{eventInfo.address}</p>
                        </div>
                        <div className='events__date_items'>
                            <img src={calendarIcon} />
                            <p>{formatDate(eventInfo.start)}</p>
                        </div>
                    </div>
                    <div
                        className={`events__join_button ${
                            eventInfo.isAvailableJoin ? 'active' : ''
                        }`}
                    >
                        <button
                            disabled={!eventInfo.isAvailableJoin}
                            onClick={handleJoinClick}
                        >
                            {translations.join}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EventsJoin;
